export const API = process.env.REACT_APP_API_URL ?? '';

export const DOTELL_URL = process.env.REACT_APP_DOTELL_URL ?? '';

export const ADMIN_IMAGES_URL = process.env.REACT_APP_ADMIN_IMAGES_URL ?? '';

export const MENU_IMAGES_URL = process.env.REACT_APP_MENU_IMAGES_URL ?? '';

export const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_URL ?? '';

export const TERMS_CONDITIONS_URL = process.env.REACT_APP_TERMS_URL ?? '';
